import { apiFirst, apiListAll } from '@/core/api/resources'

export type AnwesenheitOption = { id: string; name: string }

export async function listAnwesenheit(): Promise<AnwesenheitOption[]> {
  const rows = await apiListAll('/anwesenheit', { order: 'name' })
  return rows.map((r) => ({ id: r.id, name: r.name }))
}

export async function anwesenheitIdByName(name: string): Promise<string | null> {
  const row = await apiFirst('/anwesenheit', { name, limit: 1 })
  return row?.id ?? null
}
